import { mq } from '@olxeu-a2b/ui/src/commons/styles';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { Headline4 } from '@nexus/lib-react/dist/core/Typography/Heading';
import styled from '../../../../../theme/styled';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space[16]};
  padding: ${({ theme }) => theme.space[16]};
  box-sizing: border-box;

  div {
    box-sizing: border-box;
  }

  ${mq.desktop} {
    padding: ${({ theme }) => theme.space[16]} 0;
    grid-template-columns: repeat(auto-fill, minmax(403px, 1fr));
  }
`;

const GridElement = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors['background-global-primary']};
  padding: ${({ theme }) => theme.space[16]};

  &:first-of-type {
    padding: 0;

    ${mq.desktop} {
      padding: ${({ theme }) => theme.space[32]};
    }
  }

  ${mq.desktop} {
    padding: ${({ theme }) => theme.space[32]};
  }
`;

const GridCardHeader = styled(Headline4)`
  font-size: ${({ theme }) => theme.fontSizes[20]};
  line-height: ${({ theme }) => theme.lineHeights[22]};
`;

const GridCardSubtitle = styled(Paragraph4)`
  color: ${({ theme }) => theme.colors['text-global-secondary']};
  font-size: ${({ theme }) => theme.fontSizes[12]};
  line-height: ${({ theme }) => theme.lineHeights[14]};
  margin-top: ${({ theme }) => theme.space[10]};
`;

const GridCardContent = styled.div`
  margin-top: ${({ theme }) => theme.space[8]};

  ${mq.desktop} {
    margin-top: ${({ theme }) => theme.space[24]};
  }
`;

export default {
  Grid,
  GridCardHeader,
  GridCardSubtitle,
  GridCardContent,
  GridElement,
};
